import {getCheckoutClient} from '../config/CheckoutClient';
import {getEmail, getDefaultAddress} from '../selectors/member';
import { addServerErrors } from './ui';
import { sendSlackMessage } from 'listing/actions/general';

export function setTos(accepted) {
    return {type: "SET_TOS", accepted};
}

export function addPayment(payment) {
    return {type: "ADD_PAYMENT", payment};
}

export function setTerminal(terminalId) {
    return {type: "SET_TERMINAL_ID", terminalId};
}

export function setTerminals(terminals) {
    return {type: "SET_TERMINALS", terminals};
}

export function setStripeTerminal(stripeTerminal) {
    return {type: "SET_STRIPE_TERMINAL", stripeTerminal};
}

export function setConnectedTerminal(connectedTerminal) {
    return {type: "SET_CONNECTED_TERMINAL", connectedTerminal};
}

export function setIsReaderConnected(isReaderConnected) {
    return (dispatch, getState) => {
        if(isReaderConnected === false) {
            dispatch(sendSlackMessage("@here EMV terminal not connected", "error"));
        } else {
            dispatch(sendSlackMessage("EMV terminal connected successfully", "ok"));
        }

        dispatch({type: "SET_IS_READER_CONNECTED", isReaderConnected});
    }
}

export function zeroDollarPayment() {
    return (dispatch, getState) => {
        let state = getState();
        var address = getDefaultAddress(state);
        var payload = {
            amount: 0,
            email: getEmail(state),
            ...address,
            tos_accepted: state.payment.tosAccepted,
            emailOptOut: state.member.emailOptOut,
        };

        if (state.member.createdNewAccount) {
            payload.sendAccountEmail = 1;
        }

        return getCheckoutClient(state.ui.apiUrl).reservationCreateRequest(state.reservation.token, 'payment', payload, state.reservation.secret).then((result) => {
            dispatch(addPayment(result.body.data));
            return Promise.resolve(true);
        }).catch((error) => {
            dispatch(addServerErrors(error.response.body.errors));
            return Promise.reject();
        });
    }
}

/**
 * Create a payment intent
 */
export function createStripePaymentIntent(amount) {
    return (dispatch, getState) => {
        const state = getState();
        let body = {token: state.reservation.token, payment: amount};
        let req = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        };

        return fetch(state.ui.apiUrl + '/stripepayments/create_payment_intent', req).then(res => {
            if(res.status === 200) {
                return res.json();
            } else {
                throw new Error(res);
            }
        });
    }
}

/**
 * Creates payment intent and attempts to process payment if no further action required
 */
export function createStripePaymentIntentAndCapture(payload) {
    return (dispatch, getState) => {
        const state = getState();
        let req = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'reservation-secret': state.reservation.secret
            },
            body: JSON.stringify({token: state.reservation.token, ...payload}),
        };
        return fetch(state.ui.apiUrl + '/stripepayments/create_payment_intent_and_capture', req).then(res => {
            return res.json();
        });
    }
}

/**
 * Confirms payment intent and attempts to process payment
 */
export function confirmStripePaymentIntentAndCapture(payload) {
    return (dispatch, getState) => {
        const state = getState();
        let req = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'reservation-secret': state.reservation.secret
            },
            body: JSON.stringify({token: state.reservation.token, ...payload})
        };
        return fetch(state.ui.apiUrl + '/stripepayments/confirm_payment_intent_and_capture', req).then(res => {
            return res.json();
        });
    }
}

/**
 * Cancel payment intent
 */
export function cancelStripePaymentIntent(paymentIntentId, secret) {
    return (dispatch, getState) => {
        const state = getState();
        let req = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({token: state.reservation.token, payment_intent_id: paymentIntentId, client_secret: secret})
        };
        return fetch(state.ui.apiUrl + '/stripepayments/cancel_payment_intent', req).then(res => {
            return res.json();
        });
    }
}
